export type TaktikalAuthMethod = 'phone' | 'ssn'

/** Icelandic kennitala length (digits only). */
export const SSN_LENGTH = 10

/** Strip everything except digits, preserving only a single leading `+`. */
export const normalizePhoneNumber = (value: string) => {
	const hasLeadingPlus = value.trimStart().startsWith('+')
	const digits = value.replace(/\D/g, '')
	return hasLeadingPlus ? `+${digits}` : digits
}

/** Strip everything except digits from an SSN/kennitala. */
export const normalizeSsn = (value: string) => value.replace(/\D/g, '')

/** SSNs are only valid when they contain exactly `SSN_LENGTH` digits. */
export const isValidSsn = (normalized: string) => normalized.length === SSN_LENGTH
